/**
 * @class WidgetModel
 * A basic data model for Widgets. Makes it easier to access and mutate
 * widget properties
 * Shared between the admin system and the public site
 * @param {object} data
 */
export default class WidgetModel {
	constructor (data) {
		const { configuration: {
			position, requiredFields, style
		}, type } = data;

		// We need to transform any existing arrays into objects
		const transformedRequiredFields = type === 'SIGNUP_FORM' && Array.isArray(requiredFields) ? requiredFields.reduce((acc, field) => {
			acc[field] = true;
			return acc;
		}, {}) : requiredFields;

		Object.defineProperties(this, {
			configuration: {
				configurable: false,
				enumerable: false,
				writable: true,
				value: {
					...data.configuration,
					requiredFields: transformedRequiredFields,
					position: position || 'absolute',
					style: style || {}
				}
			},
			location: {
				configurable: false,
				enumerable: false,
				writable: false,
				value: data.location
			},
			position: {
				configurable: false,
				enumerable: false,
				writable: true,
				value: data.position
			},
			type: {
				configurable: false,
				enumerable: false,
				writable: false,
				value: data.type
			},
			id: {
				configurable: false,
				enumerable: false,
				writable: false,
				value: data.id
			},
			isDeleted: {
				configurable: false,
				enumerable: true,
				writable: true,
				value: data.isDeleted === true
			},
			isComplete: {
				configurable: false,
				enumerable: true,
				writable: true,
				value: data.isComplete === true
			},
			template: {
				configurable: false,
				enumerable: true,
				writable: false,
				value: data.template || ''
			},
			deletionConfirmation: {
				configurable: false,
				enumerable: false,
				writable: false,
				value: data.deletionConfirmation || {
					prompt: 'Are you sure you want to delete this widget?'
				}
			}
		});
	}

	get asJson () {
		return {
			configuration: this.configuration,
			location: this.location,
			position: this.position,
			type: this.type,
			id: this.id,
			isComplete: this.isComplete,
			isDeleted: this.isDeleted
		};
	}

	get asString () {
		return JSON.stringify(this.getAsJson());
	}

	get dockableEdges () {
		return Object.keys(this.position);
	}

	markForDeletion () {
		this.isDeleted = true;
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/stickybins/scripts/shared/classes/widget-model.js